import React, { useState } from "react";
import { Button, Box, Typography, useMediaQuery, Snackbar, Alert } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useLanguage } from "../context/LanguageContext.js";
import { logDev } from "../utils/logger.js";
import SnackbarFeedback from "../pages/SnackbarFeedback.js";

const BoutonCopierTousEmails = ({ emails, disabled }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { t } = useLanguage();
  const [bottomNavHeight, setBottomNavHeight] = useState(0);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const handleClose = () => setSnackbar({ ...snackbar, open: false });

  const cleanedEmails = Array.isArray(emails)
  ? emails
      .map(e => typeof e === "string" ? e.trim() : e?.mail?.trim())
      .filter(email => email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
  : typeof emails === "string"
  ? emails.split(",").map(e => e.trim()).filter(email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
  : [];  

  const emailList = cleanedEmails.join(", ");
  const hasEmails = cleanedEmails.length > 0;

  const handleCopy = async () => {
    if (!hasEmails) {
      setSnackbar({
        open: true,
        message: t("NoValidEmailToCopy"),
        severity: "warning"
      });
      return;
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(emailList);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = emailList;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setSnackbar({
        open: true,
        message: t("EmailsCopied"),
        severity: "success"
      });
    } catch (err) {
      logDev("❌ Erreur copie emails", { message: err.message, stack: err.stack });
      setSnackbar({
        open: true,
        message: t("ErrorCopyingEmails"),
        severity: "error"
      });
    }
  };

  const button = (
    <Button
      variant="contained"
      onClick={handleCopy}
      disabled={disabled}
      sx={{
        backgroundColor: "#3399FF !important",
        color: "#fff !important",
        marginLeft: 1,
        marginTop: 1,
        fontWeight: "bold",
        width: 60,
        height: 60,
        fontSize: isMobile ? "1.5rem" : "2rem",
        minHeight: isMobile ? "10px" : "20px",
        minWidth: isMobile ? "20px" : "auto",
        padding: 2,
        borderRadius: 15,
        "&:hover": {
          backgroundColor: "#027bb5",
          transform: "scale(1.05)"
        }
      }}
    >
      <ContentCopyIcon />
    </Button>
  );

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
      <Button
        variant="contained" 
        onClick={handleCopy}
        disabled={disabled}
        sx={{
          backgroundColor: "#3399FF !important",
          color: "#fff !important",
          marginLeft: 1,
          marginTop: 1,
          fontWeight: "bold",
          fontSize: isMobile ? "1.5rem" : "2rem",
          transition: "all 0.3s ease",
          width: 60,
          height: 60,
          minHeight: isMobile ? "10px" : "20px",
          minWidth: isMobile ? "20px" : "auto",
          padding: 1,
          borderRadius: 15,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            backgroundColor: "#128C7E",
            transform: "scale(1.05)"
          }
        }}
      >
        <ContentCopyIcon fontSize="small" />
       {/*{t("CopyAllEmails")}*/}
      </Button>

      <Typography 
      variant="caption" 
      sx={{ 
        mt: 1, 
        color: "#555",
        textAlign: "center"
         }}>
        {hasEmails
          ? `${cleanedEmails.length} ${t("EmailsAvailableToCopy")}`
          : t("NoValidEmailToCopy")}
      </Typography>

    </Box>

    <SnackbarFeedback
            snackbar={snackbar}
            setSnackbar={setSnackbar}
            bottomNavHeight={bottomNavHeight}
        />
      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{ transform: "translateY(-50px)" }} 
      >
        <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
        
      </Snackbar>

    </>


  );
};

export default BoutonCopierTousEmails;
